import React from 'react';
import './Terms.css';

function Terms() {
  return (
    <div className="terms-container">
      <div className="terms-content">
        <h1>Terms of Service</h1>
        {/* <p><strong>Effective Date:</strong> May 25, 2024</p> */}

        <h2>1. Introduction</h2>
        <p>
          Welcome to Airrived Inc. (“Company,” “we,” “us,” or “our”). These Terms of Service (“Terms”) govern your access to and use of our website, software, applications, and services (collectively, the “Services”).
          By using our Services, you agree to be bound by these Terms. If you do not agree, you must discontinue use of the Services.
        </p>

        <h2>2. Acceptance of Terms</h2>
        <p>
          By accessing or using the Services, you confirm that you have read, understood, and agree to be bound by these Terms and any other policies referenced herein, including our Privacy Policy.
          If you are using the Services on behalf of an organization, you represent and warrant that you have the authority to bind that organization to these Terms.
        </p>

        <h2>3. Description of Services</h2>
        <p>
          Airrived Inc. provides [brief description of the software services offered], including any updates, enhancements, and new features.
          We reserve the right to modify or discontinue the Services (or any part thereof) at any time, with or without notice.
        </p>

        <h2>4. Eligibility</h2>
        <p>
          You must be at least 18 years old (or the age of legal majority in your jurisdiction) to use our Services.
          By using our Services, you represent and warrant that you meet this eligibility requirement.
        </p>

        <h2>5. User Accounts</h2>
        <h3>Registration:</h3>
        <p>To use certain features of the Services, you may be required to create an account. You agree to provide accurate, current, and complete information during registration.</p>

        <h3>Security:</h3>
        <p>You are responsible for maintaining the confidentiality of your account credentials. You agree to immediately notify us of any unauthorized use of your account or any other security breach.</p>

        <h3>Account Restrictions:</h3>
        <p>You may not share your account with others or use another person’s account without permission.</p>

        <h2>6. Fees and Payment</h2>
        <h3>Subscription Plans:</h3>
        <p>Some of our Services may require payment of subscription fees. The applicable fees, billing cycles, and payment options will be disclosed during the sign-up process.</p>

        <h3>Payment:</h3>
        <p>You authorize Airrived Inc. to charge your chosen payment method for the Services. If we are unable to collect payment, we may suspend or terminate your access to the Services.</p>

        <h3>Refunds:</h3>
        <p>Any refund requests will be handled in accordance with our refund policy, if applicable. We reserve the right to grant or deny refunds at our sole discretion.</p>

        <h2>7. Intellectual Property Rights</h2>
        <p>All content, trademarks, service marks, and logos on the Services are owned by or licensed to Airrived Inc.</p>

        <h2>8. Confidentiality</h2>
        <p>You may receive information from us that is designated confidential or that reasonably should be understood to be confidential.
          You agree not to disclose such information without our prior written consent, except as required by law.</p>

        <h2>9. Prohibited Conduct</h2>
        <ul>
          <li>Violate any applicable law, regulation, or contractual agreement.</li>
          <li>Infringe upon the intellectual property or privacy rights of others.</li>
          <li>Post or transmit harmful, offensive, or illegal content.</li>
          <li>Interfere with the proper functioning of the Services, including distributing viruses or malicious code.</li>
        </ul>

        <h2>10. Warranties and Disclaimers</h2>
        <p>
          Our Services are provided “as is” and “as available.” To the fullest extent permitted by law, Airrived Inc. disclaims all warranties, express or implied.
        </p>

        <h2>11. Limitation of Liability</h2>
        <p>
          To the fullest extent permitted by law, Airrived Inc. and its affiliates shall not be liable for any indirect, incidental, special, consequential, or punitive damages.
        </p>

        <h2>12. Indemnification</h2>
        <p>
          You agree to defend, indemnify, and hold harmless Airrived Inc., its affiliates, officers, directors, employees, and agents from and against all claims, damages, obligations, and expenses.
        </p>

        <h2>13. Term and Termination</h2>
        <p>
          These Terms shall remain in effect until terminated by you or Airrived Inc. We may suspend or terminate your access to the Services at any time, for any reason, without notice.
        </p>

        <h2>14. Governing Law and Dispute Resolution</h2>
        <p>
          These Terms are governed by and construed in accordance with the laws of [applicable jurisdiction].
        </p>

        <h2>15. Changes to the Terms</h2>
        <p>
          We may update these Terms from time to time. If we make material changes, we will notify you by posting a notice on our website.
        </p>

        <h2>16. Contact Us</h2>
        <p>
          If you have any questions or concerns about these Terms, please contact us at:
        </p>
        <p><strong>Email:</strong> support@airrived.ai</p>
      </div>
    </div>
  );
}

export default Terms;